import { render, staticRenderFns } from "./RevisionVenta.vue?vue&type=template&id=210db44e"
import script from "./RevisionVenta.vue?vue&type=script&lang=js"
export * from "./RevisionVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports